import React from 'react';
import update from 'immutability-helper';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Clearfix, Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { forEach as _forEach } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import List from 'components/List';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import Loader from 'components/layout/Loader';
import CategoryFacetTableRow from 'components/layout/item/CategoryFacetTableRow';
import CategoryFacetData from 'components/layout/item/CategoryFacetData';

class CategorySearchSettings extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));
  };

  // add new facet using dropdown
  addFacet = attribute => {
    let { entity, changeEntity } = this.props;

    // check if attribute is already selected; if so, do not do anything
    let alreadySelected = false;
    _forEach(entity.getFacets(), facet => {
      if (facet.getAttribute().getId() === attribute.id) {
        alreadySelected = true;
      }
    });

    if (alreadySelected) {
      return null;
    }

    const data = {
      attribute,
      display: 'list',
      isMultiple: true,
    };

    const newFacet = entity.createValue('facets', [], data);
    const newValue = entity.getFacets().slice();
    newValue.push(newFacet);
    const newEntity = { ...entity.updateValue('facets', newValue, []) };

    changeEntity(newEntity);
  };

  handleRemoveClick = (e, index) => {
    e.preventDefault();
    e.stopPropagation();

    this.removeEntry(index);
  };

  removeEntry = index => {
    const { entity, changeEntity } = this.props;
    const newValue = entity.getFacets().slice();
    newValue.splice(index, 1);
    const newEntity = { ...entity.updateValue('facets', newValue, []) };

    changeEntity(newEntity);
  };

  // when dragging, move the facets
  moveFacets = (fromIndex, toIndex) => {
    const { entity, changeEntity } = this.props;

    const myData = { facets: entity.getFacets().slice() };
    const facet = myData.facets[fromIndex];
    const newData = update(myData, {
      facets: {
        $splice: [[fromIndex, 1], [toIndex, 0, facet]],
      },
    });

    const newEntity = { ...entity.updateValue('facets', newData.facets, []) };

    changeEntity(newEntity);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entity,
      entityLoaded,
      changeEntity,
      disabled,
      attributes,
      user,
    } = this.props;
    const { shownIndex } = this.state;

    const columns = [messages.attribute, messages.display, messages.select_multiple, messages.actions];
    let tBody = [];
    if (entityLoaded && entity.getFacets().length) {
      const facets = entity.getFacets();
      tBody = facets.map((facet, i) => {
        const { attribute } = facet;
        return (
          <CategoryFacetTableRow
            key={i}
            messages={messages}
            data={facet}
            shownIndex={shownIndex}
            index={i}
            onClick={() => this.handleClick(i)}
            name={getNameInCurrentLanguage(attribute.name, appIntl)}
            handleRemove={e => this.handleRemoveClick(e, i)}
            hideDetails={() => this.setState({ shownIndex: null })}
            moveFacets={this.moveFacets}
            user={user}
          />
        );
      });
    }

    if (shownIndex !== null) {
      const data = entity.getFacets()[shownIndex];

      // user wants to see a facet form
      tBody.splice(
        shownIndex + 1,
        0,
        <tr key={'details-showing-' + shownIndex} class="row-details">
          <td colSpan={columns.length}>
            <CategoryFacetData
              data={data}
              index={shownIndex}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              disabled={disabled}
            />
          </td>
        </tr>
      );
    }

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <div class="padding-20 sm-padding-10">
            <List
              noRender
              listName="attributes"
              url="/api/attributes.json"
              urlData={{ filters: { categories: entity.getId() } }}
              list={attributes}
              resPerPage={200}
            />

            <Row>
              <Col xs={12}>
                <div class="form-group-attached">
                  {attributes.pending ? (
                    <Loader />
                  ) : (
                    <div>
                      <Clearfix>
                        <Col xs={12} sm={6} md={4} class="no-padding">
                          <FormAutocomplete
                            label={messages.select_attribute}
                            name="attribute"
                            onChange={(property, value) => {
                              this.addFacet(value);
                            }}
                            disabled={disabled}
                            autocompleteType="attribute"
                            returnValueObject
                          />
                        </Col>
                      </Clearfix>

                      <Table responsive hover class="table-detailed">
                        <thead>
                          <tr>
                            {columns.map((column, i) => {
                              return (
                                <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                                  {column}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <ReactCSSTransitionGroup
                          transitionName="tablerows"
                          transitionEnterTimeout={500}
                          transitionLeaveTimeout={1}
                          component="tbody"
                        >
                          {tBody}
                        </ReactCSSTransitionGroup>
                      </Table>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}
CategorySearchSettings.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    attributes: state.list.attributes,
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(CategorySearchSettings));
